import * as React from "react";
import { Text } from "react-native";

import { isWeb } from "~/lib/constants";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  useDialog,
} from "~/ui/Dialog";

function isFocusable(element: HTMLElement) {
  const focusableSelectors =
    'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
  return (
    element.matches(focusableSelectors) && !element.hasAttribute("disabled")
  );
}

export function Modal(props: {
  header?: React.ReactNode;
  onDismiss: () => void;
  children:
    | React.ReactNode
    | ((props: { dismiss: () => void }) => React.ReactNode);
}) {
  const { header, onDismiss, children: Content } = props;
  const { open: spaceDialogOpen, closeDialog } = useDialog(true);
  function dismiss() {
    closeDialog();
    onDismiss();
  }
  return (
    <Dialog
      open={spaceDialogOpen}
      onOpenChange={(open) => {
        if (!open) {
          dismiss();
        }
      }}
    >
      <DialogContent
        onOpenAutoFocus={(e) => {
          if (!isWeb) return;
          const element = (e.currentTarget as HTMLElement).querySelector(
            "[data-autofocus]",
          ) as HTMLElement | null;
          if (!element) return;

          if (isFocusable(element)) {
            e.preventDefault();
            element.focus();
          }
        }}
        className="bg-surface-tertiary p-4 has-[.tiptap]:max-w-6xl"
      >
        {header && (
          <DialogHeader>
            {typeof header === "string" ? (
              <DialogTitle>
                <Text className="text-text-primary">{header}</Text>
              </DialogTitle>
            ) : (
              header
            )}
          </DialogHeader>
        )}
        {typeof Content === "function" ? (
          <Content dismiss={dismiss} />
        ) : (
          Content
        )}
      </DialogContent>
    </Dialog>
  );
}
